// Oversight-level vocabulary for the per-run run-start selector.
// Operator-facing concept = "oversight level" (oversight AMOUNT, not "trust").
// `NONE` is the fully-unattended, v1.2-parity level: the workflow asks for no
// approvals and commits the endorsement on its own. It is opt-in and never the
// default (the form default is LOW). (NONE still stops for structural work no
// automation can replace —
// the carrier handoff, MFA if challenged, and the additional-interest picker —
// exactly as v1.2 does.)

export type OversightLevel = "HIGH" | "MEDIUM" | "LOW" | "NONE";

export interface OversightLevelOption {
  value: OversightLevel;
  label: string;       // e.g. "High"
  description: string; // plain-language oversight-AMOUNT copy
}

// Order: HIGH -> MEDIUM -> LOW -> NONE (most -> least oversight).
export const OVERSIGHT_LEVEL_OPTIONS: readonly OversightLevelOption[] = [
  { value: "HIGH",   label: "High",   description: "Asks before most steps." },
  { value: "MEDIUM", label: "Medium", description: "Asks on important steps." },
  { value: "LOW",    label: "Low",    description: "Asks only on the riskiest." },
  { value: "NONE",   label: "None",   description: "No approvals — runs unattended, including committing the endorsement (like v1.2)." },
];

export const DEFAULT_OVERSIGHT_LEVEL: OversightLevel = "LOW";

/** Hover copy for the form's oversight `?` — every level, not just the current one. */
export const OVERSIGHT_LEVEL_HELP = OVERSIGHT_LEVEL_OPTIONS.map(
  (opt) => `${opt.label} — ${opt.description}`,
).join("\n");
